module.exports = __webpack_public_path__ + "images/img-3oBl5Mk.svg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/market/cpaclub.svg
// module id = 1934
// module chunks = 0